import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col-md-5 text-md-end mb-4" }
const _hoisted_3 = {
  class: "d-inline-block rounded-1",
  style: {"border":"1px solid #dde4ff","background-color":"#ecf0ff","padding":"1px 10px"}
}
const _hoisted_4 = { class: "text-primary ms-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-md-7" }, [
      _createElementVNode("div", { class: "mb-3 mb-md-4" }, [
        _createElementVNode("h3", { class: "fs-20 fw-semibold mb-1" }, "School Overview Dashboard"),
        _createElementVNode("p", { style: {"line-height":"1.4"} }, " Manage Students, Teachers, and School Data Seamlessly! ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ri-calendar-line text-primary" }, null, -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.fulldate), 1)
      ])
    ])
  ]))
}